/**
 * Facade for api available on the window
 * This is helpful to keep track of methods used and auto-mocking the implementation
 */
const analytics = {
  trackLink(...args) {
    window.analytics.trackLink(...args);
  },
  track(...args) {
    window.analytics.track(...args);
  },
  identify(...args) {
    window.analytics.identify(...args);
  },
  alias(...args) {
    window.analytics.alias(...args);
  },
  page(...args) {
    window.analytics.page(...args);
  }
};

export default analytics;
